module.exports = __webpack_public_path__ + "static/media/ic_audio_on_disable.bf891928.svg";